import { Link } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import DEFAULT_USERPIC from "@/common/images/icons/default_userpic.svg";
import { INiche } from "@/common/services/types";

import { Image } from "@/components/Image";

import "./NichePreviewAvatar.scss";

interface IProps {
  niche: INiche;
  onPreviewClick?: () => void;
}

export const NichePreviewAvatar = ({ niche, onPreviewClick }: IProps) => {
  return (
    <Link className="NichePreviewAvatar" to={routes.niche(niche.id)} onClick={onPreviewClick} aria-label={`Link to ${niche.name} niche`}>
      <Image src={niche.thumbnail ?? DEFAULT_USERPIC} alt={`Avatar for ${niche.name} niche`} />
    </Link>
  );
};
